import React, { useEffect, useState } from 'react';
import BackButton from '../components/BackButton';
import LoadingSpinner from '../components/LoadingSpinner';
import {
  getDefault,
  removeDefault,
  setDefault
} from '../services/icon.service';
import { SetIconRequest } from '../models/api';
import DeleteButton from '../components/DeleteButton';
import ImageUploader from '../components/ImageUploader';
import ImagePreview from '../components/ImagePreview';
import Feedback from '../components/Feedback';

const DefaultThemeDetails: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState(false);
  const [hasDefaultIcon, setHasDefaultIcon] = useState<boolean | null>(null);
  const [existingFileName, setExistingFileName] = useState<string | null>(null);
  const [existingBlobName, setExistingBlobName] = useState<string | null>(null);

  const [errors, setErrors] = useState([] as string[]);
  const [message, setMessage] = useState('');

  const getData = async () => {
    setLoading(true);
    setErrors([]);

    const result = await getDefault();

    if (result.success && result.data) {
      setHasDefaultIcon(result.data.hasIcon);
      setExistingFileName(result.data.fileName);
      setExistingBlobName(result.data.blobName);
    } else {
      setErrors(result.errors);
    }

    setLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  const deleteDefault = async () => {
    setDeleting(true);

    setErrors([]);

    const result = await removeDefault();
    if (result.success) {
      setMessage('Default icon removed');
      await getData();
    } else {
      setErrors(result.errors);
    }
    setDeleting(false);
  };

  const handleSave = async (
    selectedFile: File | null,
    selectedFileContents: string | null
  ) => {
    setErrors([]);

    if (!selectedFile) {
      setErrors(['Please select an image to use']);
      return false;
    }

    if (!selectedFileContents) {
      setErrors(['Cannot load image, please use a different file']);
      return false;
    }

    const request: SetIconRequest = {
      fileContents: selectedFileContents,
      fileName: selectedFile.name
    };

    const result = await setDefault(request);

    if (result.success && result.data) {
      setHasDefaultIcon(result.data.hasIcon);
      setExistingFileName(result.data.fileName);
      setExistingBlobName(result.data.blobName);

      setMessage('Default icon updated');
      return true;
    } else {
      setErrors(result.errors);
    }

    return false;
  };

  if (loading) {
    return (
      <>
        <h2>Default Themes</h2>
        <LoadingSpinner />
      </>
    );
  }

  return (
    <>
      <h2>Default Themes</h2>
      <h3>Default icon</h3>
      <p>
        This icon will be used on the welcome screen for all events, unless a
        different icon is selected when setting up that event.
      </p>
      <Feedback messages={errors} type="error" />
      <Feedback message={message} type="success" />
      {hasDefaultIcon === false && <p>No default icon has been provided.</p>}
      {/* {hasDefaultIcon === true && existingBlobName && (
        <form className="content-form">
          <h3>Current icon</h3>
          <ImagePreview
            existingFileName={existingFileName}
            existingBlobName={existingBlobName}
          />
          <DeleteButton
            isLoading={deleting}
            onClick={deleteDefault}
            message="Are you sure you want to remove the default icon?"
          >
            Remove default
          </DeleteButton>
        </form>
      )} */}
      <form className="content-form">
        <h3>Change icon</h3>
        <ImageUploader
          onSave={handleSave}
          buttonText="Set as default icon"
          isDeleting={deleting}
          removeWelcomeImage={deleteDefault}
          existingWelcomeImageBlobName={existingBlobName}
          existingWelcomeImageFileName={existingFileName}
        />
      </form>
    </>
  );
};

export default DefaultThemeDetails;
